<template>
	<div>
		<vxe-modal size="mini" v-model="model" width="800" height="600" :show-footer="false" destroy-on-close
			@show="show" @hide="hide" transfer :lock-scroll="false" :showHeader="true" title="统计表下载" :loading="loading">
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent" ref="deliverytool"></vxe-grid>
				<exportTable :ref="exportRef" listType="report" />
			</template>
		</vxe-modal>
		<CKFY-index :data="currentrow" ref="CKFY" />
		<SHTJ-index :data="currentrow" ref="SHTJ" />
		<YSZD-index :data="currentrow" ref="YSZD" />
		<QGCDDDRK-index :data="currentrow" ref="QGCDDDRK" />
		<YSZKTJ-index :data="currentrow" ref="YSZKTJ" />
		<KFJX-index :data="currentrow" ref="KFJX" />
		<XPGZ-index :data="currentrow" ref="XPGZ" />
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import exportTable from '@_system/components/export/index.vue'
	import CKFYIndex from './config/CKFY/index.vue'
	import SHTJIndex from './config/SHTJ/index.vue'
	import YSZDIndex from './config/YSZD/index.vue'
	import QGCDDDRKIndex from './config/QGCDDDRK/index.vue'
	import YSZKTJIndex from './config/YSZKTJ/index.vue'
	import KFJXIndex from './config/KFJX/index.vue'
	import XPGZIndex from './config/XPGZ/index.vue'
	export default {
		mixins: [listMixins],
		props: {
			data: {
				type: Array,
				default: () => {
					return []
				}
			},
			action: {
				default: () => {
					return ''
				}
			}
		},
		data() {
			return {
				currentrow:null,
				loading: false,
				model: true,
				tableList: [],
				orderinfo: [],
				gridOptions: null,
				tabledata: [],
				exportRef: 'export_' + Math.random(),
				primarykey: '业务订单号',
				buff: true,
				isfinish: true,
				totalNum: 0,
				progress: 0
			}
		},
		created() {

		},
		mounted() {
			//console.log(this.data)
			this.data.forEach((item) => {
				this.getorderinfo(item)
			})
		},
		watch: {

		},
		computed: {

		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				let deliveryname = []
				let controlltype = []
				for (let i in this.logistics) {
					deliveryname.push({
						label: this.logistics[i],
						value: this.logistics[i]
					})
				}
				for (let i in this.controlltype) {
					controlltype.push({
						label: this.controlltype[i],
						value: this.controlltype[i]
					})
				}
				gridOptions.height = 500
				gridOptions.importConfig = {
					remote: true,
					importMethod: this.importMethod
				}

				gridOptions.editRules = {
					bizId: [{
						required: true,
						message: false
					}],
					cpName: [{
						required: true,
						message: false
					}],
					delivery_controll: [{
						required: true,
						message: false
					}]
				}
				gridOptions.columns = [{
						field: 'code',
						title: '编码',
					},{
						field: 'name',
						title: '统计表名称',
					},
					{
						field: '',
						title: '操作',
						width: 65,
						fixed: "right",
						align: 'center',
						cellRender: {
							bind: this,
							name: '$operateButton',
							buttons: [{
								code: 'download',
								content: '下载',
								status: 'primary',
								inrow: true
							}]
						}
					}
				]
				gridOptions.toolbarConfig.buttons = []
				gridOptions.formConfig = false
			},
			toolsSubmit(data) {
				//console.log(this.$refs.deliverytool.getTableData())
				let tableData = this.$refs.deliverytool.getTableData().tableData
				tableData.forEach((item) => {
					for (let i in data.data) {
						item[i] = data.data[i]
					}
				})
			},
			operateButtonClickEvent(e) {
				if (this[e.code]) {
					this[e.code](e.data)
				}
			},
			download(e){
				this.currentrow = e
				this.$nextTick(()=>{
					this.$refs[e.code].modal_show()
				})
			},
			list() {
				return new Promise((resolve) => {
					resolve({
						list: [{
							id:'CKFY',
							code:'CKFY',
							name:'仓库费用'
						},
						{
							id:'SHTJ',
							code:'SHTJ',
							name:'售后统计'
						},
						{
							id:'YSZD',
							code:'YSZD',
							name:'原始账单统计'
						},
						{
							id:'QGCDDDRK',
							code:'QGCDDDRK',
							name:'全国仓订单待入库统计'
						},
						{
							id:'YSZKTJ',
							code:'YSZKTJ',
							name:'应收账款统计'
						},
						{
							id:'KFJX',
							code:'KFJX',
							name:'客服绩效'
						},
						{
							id:'XPGZ',
							code:'XPGZ',
							name:'新品跟踪'
						},
						]
					})
				})
			},
			show() {
				this.progress = 0
				this.buff = true
			},
			hide() {
				this.progress = 0
				this.buff = false
				this.$emit('hide')
			},
		},
		components: {
			exportTable,
			CKFYIndex,
			SHTJIndex,
			YSZDIndex,
			QGCDDDRKIndex,
			YSZKTJIndex,
			KFJXIndex,
			XPGZIndex
		}
	}
</script>